module.exports = __webpack_public_path__ + "static/assets/93ca8141f902e057625de0891236288c.svg";